import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureRemixErrorBoundaryError } from '@sentry/remix';

import OffersCarouselComponent, { type OffersCarouselIndexProps } from '@cx-modules/offers-carousel';

import { useOffersClickoutServiceProps } from '~/hooks/use-offers-clickout-service';

const isFE = typeof window !== 'undefined';

export const OffersCarousel = (propsIn: OffersCarouselIndexProps) => {
  const { i18n } = useTranslation();
  const clickoutServiceProps = useOffersClickoutServiceProps();

  const props = isFE
    ? {
        ...propsIn,
        analyticsDataLayer: window.dataLayer,
        ...clickoutServiceProps,
        i18n,
      }
    : {
        ...propsIn,
        ...clickoutServiceProps,
        i18n,
      };

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureRemixErrorBoundaryError(error);
        return null;
      }}
    >
      <OffersCarouselComponent {...props} />
    </ErrorBoundary>
  );
};

type OffersContentContractProps = {
  [key: string]: unknown;
  geoTargeting?: boolean | string;
  repub: string;
  subdivision?: string;
};

export const OffersCarouselContentContractForPageTemplate = ({
  geoTargeting,
  repub,
  subdivision,
  ...props
}: OffersContentContractProps) => {
  return {
    ...props,
    apiKey: ENV.OC_API_KEY[repub as keyof typeof ENV.OC_API_KEY],
    subdivisionCode: subdivision,
    theme: `oc${repub.toLowerCase()}`,
    repub,
    geoTargeting,
    ...(geoTargeting === false
      ? {
          countryCode: undefined,
          subdivisionCode: undefined,
        }
      : {}),
  };
};
